import React from "react";
import "../styles/Home.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { HiOutlineMail } from "react-icons/hi";
import { FaArtstation } from "react-icons/fa";
import Angel3 from "../components/Angel3";

function Home() {

  return (
    <div className="container">
    <Angel3 />
        <div className="homepage-icons">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/maryambani"
            className="icon-inverted"
          >
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/maryam-bani-otero/"
            className="icon-inverted"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.artstation.com/niflemdraws"
            className="icon-inverted"
          >
            <FaArtstation />
          </a>
          <a href="mailto:maryam.bani-otero@hotmail.com" className="icon-inverted">
            <HiOutlineMail />
          </a>
        </div> 
       </div>
  );
}

export default Home;
